var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.4233 3.84859C7.4233 4.95316 6.52787 5.84859 5.4233 5.84859C4.31873 5.84859 3.4233 4.95316 3.4233 3.84859C3.4233 2.74402 4.31873 1.84859 5.4233 1.84859C6.52787 1.84859 7.4233 2.74402 7.4233 3.84859ZM5.4233 7.18193C7.26425 7.18193 8.75663 5.68954 8.75663 3.84859C8.75663 2.00764 7.26425 0.515259 5.4233 0.515259C3.58235 0.515259 2.08997 2.00764 2.08997 3.84859C2.08997 5.68954 3.58235 7.18193 5.4233 7.18193ZM5.4233 7.18193C8.36882 7.18193 10.7566 9.56974 10.7566 12.5153H9.4233C9.4233 10.3061 7.63244 8.51526 5.4233 8.51526C3.21416 8.51526 1.4233 10.3061 1.4233 12.5153H0.0899658C0.0899658 9.56974 2.47778 7.18193 5.4233 7.18193Z",
    fill: "#0071E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/Person.b91dca2af0add33e38e56b91f1ed364c.svg";
export { ForwardRef as ReactComponent };